// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__248XA","noInteraction":"EventWrapper_noInteraction__13Vh-"};